import { render } from "./Signout.vue?vue&type=template&id=4a362d5a"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Signout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a362d5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a362d5a', __exports__)) {
    api.reload('4a362d5a', __exports__)
  }
  
  module.hot.accept("./Signout.vue?vue&type=template&id=4a362d5a", () => {
    api.rerender('4a362d5a', render)
  })

}


export default __exports__